import { type BbkClientConfig } from '@bbkAdminRedux/rtkq/preauth-company.slice';

export const getCurrentBaseURI = () => {
  const ret = `${window.location.protocol}//${window.location.hostname}`;
  const port = window.location.port;
  if (port !== '') {
    return `${ret}:${port}`;
  }
  return ret;
};

export const isAlternatePortOnConfiguredHost = (
  currentBaseURI: string,
  config: BbkClientConfig
) => {
  const current = new URL(currentBaseURI);

  return [config.base_uri, config.base_retention_uri]
    .filter(Boolean)
    .some((configuredBaseURI) => {
      const configured = new URL(configuredBaseURI);
      return (
        current.protocol === configured.protocol &&
        current.hostname === configured.hostname &&
        current.port !== '' &&
        current.port !== configured.port
      );
    });
};

export const shouldCorrectBaseURI = (
  currentBaseURI: string,
  config: BbkClientConfig
) =>
  !config.is_test &&
  currentBaseURI !== config.base_uri &&
  currentBaseURI !== config.base_retention_uri &&
  !isAlternatePortOnConfiguredHost(currentBaseURI, config) &&
  !currentBaseURI.endsWith(':8443') &&
  !currentBaseURI.endsWith(':8080') &&
  !currentBaseURI.includes('host.docker.internal');

export const correctBaseURI = (config: BbkClientConfig) => {
  const current = getCurrentBaseURI();
  if (shouldCorrectBaseURI(current, config)) {
    if (
      current.includes('chargebee.com') ||
      current.includes('brightback') ||
      current.includes('brtbck.net') ||
      current.includes('localhost')
    ) {
      if (current.includes('chargebee.com')) {
        window.location.replace(
          window.location.toString().replace(current, config.base_retention_uri)
        );
      } else {
        window.location.replace(
          window.location.toString().replace(current, config.base_uri)
        );
      }
    } else {
      // go to TLD
      window.location.replace(
        `http://${window.location.hostname.split('.').slice(-2).join('.')}`
      );
    }
  }
};
